import React, { useEffect, useState, useRef, useContext } from 'react'
import ReactModal from 'react-modal'
import GreenFrame from '../../../assets/early/svg/GreenFrame.svg'
import { ReactComponent as ConfirmationPlant } from '../../../assets/early/svg/ConfirmationPlant.svg'
import { useTranslation } from 'react-i18next'
import { AnimalImages } from '../../../assets/early/animals/AnimalImagesPNG'
import { EMOTION_ANIMAL_BACKGROUND_COLOR } from '../constants/Constants'
import { ANALYTICS_EVENTS } from '../../../analytics/events'
import useTrackedSurface from '../../../analytics/useTrackedSurface'
import '../../../styles/early/earlyMotion.css'

function ToastEmotionModal({ modalVisible, onConfirm = () => {}, animal = 'tiger', emotion = 'afraid' }) {
    const { t } = useTranslation()
    useTrackedSurface(ANALYTICS_EVENTS.EARLY_CLASSROOM_EMOTION_RESULT_VIEWED, {
        active: modalVisible,
        content: emotion,
    })

    useEffect(() => {
        let timeout
        if (modalVisible)
            timeout = setTimeout(() => {
                onConfirm()
            }, 4000)
        return () => {
            if (modalVisible) clearTimeout(timeout)
        }
    }, [modalVisible])

    useEffect(() => {
        if (modalVisible) {
            ReactModal.setAppElement('#root')
            document.getElementById('home').style.filter = 'blur(5px)'
        } else {
            document.getElementById('home').style.filter = 'unset'
        }
        return () => {
            document.getElementById('home').style.filter = 'unset'
        }
    }, [modalVisible])
    return (
        <ReactModal
            transparent
            ariaHideApp={false}
            isOpen={modalVisible}
            onAfterOpen={() => {}}
            onAfterClose={() => {}}
            onRequestClose={onConfirm}
            className="noScroll"
            portalClassName="ReactModalPortal em-modal-portal"
            closeTimeoutMS={240}
            style={{
                overlay: {
                    backgroundColor: '#00000065',
                    zIndex: 0,
                },
                content: {
                    padding: 0,
                    opacity: 1,
                    width: 600,
                    margin: 'auto',
                    backgroundColor: 'transparent',
                    maxHeight: '100%',
                    border: 'none',
                    boxShadow: 'none',
                    overflow: 'scroll',
                    paddingTop: 35,
                    paddingBottom: 35,
                    position: 'relative',
                },
            }}
        >
            <div className="bg-custom-gradient border-[10px] border-[#FDDF6D] h-[635px] relative rounded-[60px] mt-[5px] px-[30px] py-[20px] flex flex-col items-center overflow-hidden em-modal-card">
                <ConfirmationPlant style={{ position: 'absolute', top: 140, left: 0 }} />
                <div
                    className="em-modal-hero"
                    style={{ width: 180, height: 195, backgroundColor: '#FFFFFF26', padding: 10, borderRadius: 25, marginTop: 65 }}
                >
                    <button
                        className={`rounded-[25px] transition`}
                        style={{
                            backgroundColor: EMOTION_ANIMAL_BACKGROUND_COLOR[emotion],
                            flex: 1,
                            display: 'flex',
                            borderRadius: 15,
                            alignItems: 'center',
                            justifyContent: 'center',
                        }}
                    >
                        <img src={AnimalImages[animal ?? 'tiger'][emotion]} alt="Avatar" className="w-full h-full object-cover rounded-[25px]" />
                    </button>
                </div>
                <div className="flex flex-col items-center em-title-in em-d2">
                    <p className="text-center text-[#FDDF6D] text-[30px]  font-bold mt-[40px]">{t('Emotion successfully selected')}</p>
                    <p className="text-center text-white text-[20px] font-bold max-w-[80%] mt-[15px]">{t('Click “proceed” to get back to the class screen')}</p>
                </div>
                <div className="flex flex-row items-center justify-center gap-[20px] mt-7 em-title-in em-d3">
                    <button
                        className=" bg-no-repeat bg-contain flex  items-center justify-center  pl-[15px] pr-[11px] em-tap em-tap--card"
                        style={{ backgroundImage: `url(${GreenFrame})`, width: 160, height: 65 }}
                        onClick={onConfirm}
                    >
                        <p className="text-[30px]  font-bold text-[#5E639B]">{t('Proceed')}</p>
                    </button>
                </div>
            </div>
        </ReactModal>
    )
}

export default ToastEmotionModal
